<template>
    <div data-testid="queue-management-table">
        <div class="d-flex align-center gap-4" data-testid="queue-management-table__peek-header">
            <div class="font-weight-medium">Peek Messages</div>
            <v-spacer></v-spacer>
        </div>
        <v-card class="shadow-off mt-4" :loading="loading" :disabled="loading">
            <lb-datatablenew :headers="headers" :items="items" :enableslot="['enqueuedTime']" :loading="loading">
                <template v-slot:enqueuedTime="{ item }">
                    <span data-testid="queue-management-table__enqueued-time">{{ $nova.formatDateTime(item.enqueuedTime) }}</span>
                </template>
            </lb-datatablenew>
        </v-card>
    </div>
</template>

<script>
export default {
    name: 'QueueManagementTable',
    props: {
        items: {
            type: Array,
            default: () => [],
        },
        loading: {
            type: Boolean,
            default: false,
        },
        headers: {
            type: Array,
            default: () => [
                { text: 'Message ID', value: 'messageId', sortable: false },
                { text: 'Time Stamp', value: 'enqueuedTime', sortable: false },
            ],
        },
    },
};
</script>
